import postPresentationMode from 'Menu/components/PresentationMode/services/api/braincube';

export default postPresentationMode;
